var _circle, _path, _path2, _path3, _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreateGroupIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 2.5,
    stroke: "#1C1B1F",
    strokeLinecap: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7679 8.5C12.0332 8.04063 12.47 7.70543 12.9824 7.56815C13.4947 7.43086 14.0406 7.50273 14.5 7.76795C14.9594 8.03317 15.2946 8.47 15.4319 8.98236C15.5691 9.49472 15.4973 10.0406 15.2321 10.5C14.9668 10.9594 14.53 11.2946 14.0176 11.4319C13.5053 11.5691 12.9594 11.4973 12.5 11.2321C12.0406 10.9668 11.7054 10.53 11.5681 10.0176C11.4309 9.50528 11.5027 8.95937 11.7679 8.5L11.7679 8.5Z",
    stroke: "#1C1B1F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4058 17.507L13.8995 17.4282L13.4058 17.507ZM12.5004 18H3.50039V19H12.5004V18ZM3.08876 17.5857C3.21858 16.7717 3.53075 15.6148 4.26433 14.671C4.97971 13.7507 6.11908 13 8.00039 13V12C5.80146 12 4.37407 12.9004 3.47479 14.0573C2.5937 15.1909 2.2433 16.5374 2.10123 17.4282L3.08876 17.5857ZM8.00039 13C9.8817 13 11.0211 13.7507 11.7365 14.671C12.47 15.6148 12.7822 16.7717 12.912 17.5857L13.8995 17.4282C13.7575 16.5374 13.4071 15.1909 12.526 14.0573C11.6267 12.9004 10.1993 12 8.00039 12V13ZM3.50039 18C3.20864 18 3.05734 17.7827 3.08876 17.5857L2.10123 17.4282C1.95869 18.322 2.68757 19 3.50039 19V18ZM12.5004 19C13.3132 19 14.0421 18.322 13.8995 17.4282L12.912 17.5857C12.9434 17.7827 12.7921 18 12.5004 18V19Z",
    fill: "#1C1B1F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2976 17.4162L16.8126 17.5377L17.2976 17.4162ZM11.8008 13.9811L11.5328 13.559L11.0179 13.886L11.4394 14.3267L11.8008 13.9811ZM13.4055 17.507L13.8992 17.4282L13.4055 17.507ZM16.3961 18H12.5001V19H16.3961V18ZM16.8126 17.5377C16.8664 17.7526 16.7086 18 16.3961 18V19C17.2668 19 18.0163 18.2277 17.7826 17.2948L16.8126 17.5377ZM13.5011 14C14.5288 14 15.2506 14.5027 15.7794 15.2069C16.3188 15.9253 16.6355 16.8306 16.8126 17.5377L17.7826 17.2948C17.5915 16.5315 17.2339 15.4787 16.5791 14.6065C15.9136 13.7203 14.9212 13 13.5011 13V14ZM12.0688 14.4033C12.4587 14.1557 12.927 14 13.5011 14V13C12.7327 13 12.0792 13.2121 11.5328 13.559L12.0688 14.4033ZM11.4394 14.3267C12.3865 15.3169 12.7648 16.6647 12.9117 17.5857L13.8992 17.4282C13.7398 16.4286 13.3159 14.8419 12.1621 13.6355L11.4394 14.3267ZM12.9117 17.5857C12.9431 17.7827 12.7918 18 12.5001 18V19C13.3129 19 14.0418 18.322 13.8992 17.4282L12.9117 17.5857Z",
    fill: "#1C1B1F"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16.25,
    y: 5.25,
    width: 4.5,
    height: 0.5,
    rx: 0.25,
    stroke: "#1C1B1F",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18.75,
    y: 3.25,
    width: 4.5,
    height: 0.5,
    rx: 0.25,
    transform: "rotate(90 18.75 3.25)",
    stroke: "#1C1B1F",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateGroupIcon);
export default __webpack_public_path__ + "static/media/createGroupIcon.7cc7d1dfad79c31b9ad28b9ec3ffe455.svg";
export { ForwardRef as ReactComponent };